import { ProfessionalCategoryDtoNameEnum } from 'woofwoof-api-public';
import { translateKey } from 'src/locales/translate';

export const mapCategoryNameToVisitCategory = (
  categoryName?: ProfessionalCategoryDtoNameEnum,
): string => {
  if (!categoryName) {
    return '';
  }

  const specializationTranslations: Record<string, string> = {
    [ProfessionalCategoryDtoNameEnum.Veterinarian]: translateKey("search.category.veterinarian"),
    [ProfessionalCategoryDtoNameEnum.Dietitian]: translateKey("search.category.dietitian"),
    [ProfessionalCategoryDtoNameEnum.Behaviorist]: translateKey("search.category.behaviorist"),
    [ProfessionalCategoryDtoNameEnum.Physiotherapist]: translateKey("search.category.physiotherapist"),
  };

  return specializationTranslations[categoryName] || categoryName;
};
